<div id="openExtendsScheduleDetail" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 *ngIf="tour != null" class="modal-title mt-0" id="mySmallModalLabel">Datos de salida | <span
            class="bold text-uppercase">{{tour.description}}</span> <span class="m-l-5 text-primary bold">(
            {{date_range}} )
            <span class="m-l-10 " style="color: #e61dc4;"> {{tour.total}} PASAJEROS</span></span></h5>
        <button type="button" class="close" data-dismiss="modal" (click)="close()">&times;</button>
      </div>
      <app-loading-modal></app-loading-modal>
      <div class="modal-body">
        <div class="card m-b-30">
          <div class="row" *ngIf="workinggroup_data != null">
            <div class="col-lg-12 m-b-10" style="margin-top: -5px;">
              <span class="badge badge-dark f-s-11">G. Trabajo: {{workinggroup_data.description}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 form__contentTbl">
              <div class="table-responsive">
                <table class="table mb-0 table-sm">
                  <thead class="thead-default">
                    <tr>
                      <th class="text-center">N° PAX</th>
                      <th>Vehículo</th>
                      <th>Turno</th>
                      <th>Etiqueta/Grupo</th>
                      <th>Responsable y Código</th>
                      <th>Hotel / Ubicacion</th>
                      <th>Teléfonos</th>
                      <th>Observaciones</th>
                      <th>Cobranzas</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngIf="bookings.length == 0">
                      <tr>
                        <td colspan="7"><span><i class="m-r-5"></i>Debe seleccionar el tours para cargar los pasajeros
                            de
                            la reservas pendientes.</span>
                        </td>
                      </tr>
                    </ng-container>
                    <ng-container *ngIf="bookings.length > 0">
                      <tr *ngFor="let item of bookings">
                        <td class="text-center">
                          {{item.quantity}}
                        </td>
                        <td>
                          <ng-container *ngIf="item.vehicle_tour_content.id == 1">
                            <span class="badge f-s-10 badge-{{item.vehicle_tour_content.class}}">{{item.vehicle_tour_content.description}}</span>
                          </ng-container>
                          <ng-container *ngIf="item.vehicle_tour_content.id == 2">
                            <span class="badge f-s-10 badge-{{item.vehicle_tour_content.class}} badge-schedule-private">{{item.vehicle_tour_content.description}}</span>
                          </ng-container> 
                        </td>
                        <td><span class="bold">{{item.shift_tour_content.description}}</span></td>
                        <td>
                          {{item.reference_voucher}}
                          <div *ngIf="item.workinggroup_id != null" style="margin-top: -4px;">
                            <span class="badge badge-dark f-s-8">{{item.workinggroups_description}}</span>                        
                          </div>
                        </td>
                        <td>
                          {{item.client}}
                          <p class="f-s-12 bold m-b-0" *ngIf="item.is_received"><span
                              class="badge badge-success">Recibido</span> | {{item.agency_reponsible}}</p>
                          <p class="m-b-2" (click)="detailBookingExtends(item)" data-toggle="modal"
                            data-target="#openBookingsExtends">
                            <i *ngIf="item.is_favorite" class="fas fa-star m-r-2 color-favorite f-s-14"></i>
                            <span class="f-s-11 bold pointer book__code">{{item.code}}</span>
                          </p>
                          <!-- <button class="btn btn-sm f-s-9 btn-secondary bold" style="padding: 3px 5px"
                              (click)="detailBookingExtends(item)" data-toggle="modal"
                              data-target="#openBookingsExtends">detalle reserva <i
                                class="fas fa-angle-double-right m-l-2"></i></button> -->
                        </td>
                        <td>{{item.reference_location}}</td>
                        <td>
                          <div>{{item.tel_1}}</div>
                          <div *ngIf="item.tel_2 != null">
                            {{item.tel_2}}
                          </div>
                        </td>
                        <td>
                          {{item.observations}}
                          <div *ngIf="item.observation != null">
                            | <span class="bold">{{item.observation}}</span>
                          </div>
                        </td>
                        <td>
                          <ng-container *ngIf="!item.is_received">
                            {{toolsService.momeySol()}}{{item.total - item.total_paid}}
                          </ng-container>
                          <ng-container *ngIf="item.is_received">
                            <ng-container *ngIf="item.is_control_total_received">
                              {{toolsService.momeySol()}}{{item.total - item.total_paid}}
                            </ng-container>
                            <ng-container *ngIf="!item.is_control_total_received">
                              {{toolsService.momeySol()}}{{item.assigned_payment}}
                            </ng-container>                            
                          </ng-container>
                        </td>
                        <td>
                          <!-- <ng-container *ngIf="!item.is_received">
                            <button class="btn btn-sm f-s-9 btn-secondary bold" style="padding: 3px 5px"
                              (click)="extendsTransfers(item, item)" data-toggle="modal"
                              data-target="#openExtendsTransfers">Traspasar <i
                                class="fas fa-angle-double-right m-l-2"></i></button>
                          </ng-container> -->
                          <button class="btn btn-sm f-s-9 btn-secondary bold" style="padding: 3px 5px"
                              (click)="extendsTransfers(item, item)" data-toggle="modal"
                              data-target="#openExtendsTransfers">Traspasar <i
                                class="fas fa-angle-double-right m-l-2"></i></button>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary waves-effect" data-dismiss="modal"
          (click)="close()">Cerrar</button>
      </div>
    </div>
  </div>
</div>
<app-transfers-extends (onSubmitEvent)="afterTransfer($event)"></app-transfers-extends>
<app-bookings-extends (onSubmitEvent)="afterBookingDetail($event)"></app-bookings-extends>

